module.exports = __webpack_public_path__ + "img/icon_calender.e058455f.svg";